// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import './assets/icon/iconfont.css';
import axios from 'axios'



Vue.use(MintUI)
Vue.config.productionTip = false
axios.defaults.baseURL = window.configUrl;
Vue.prototype.$ajax = axios;
router.beforeEach((to, from, next) => {
  if (to.name) {
    document.title = to.name;
  }
  next();
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js